// config.js
const config = {
    chainId: 1482601649, // Nebula Gaming Hub
    rpcUrl: 'https://mainnet.skalenodes.com/v1/green-giddy-denebola',
    nebulaTokenAddress: '0xfB600ee906ce944EC9846B1b2C5CF5505Da509b4'
  };
  
  export default config;
  